mem.page('index', function () {
  function initGameMenu(difficulty) {
    $('main').on('click', '.menu-option.' + difficulty + '-game', function(e) {
      mem.showPage('game', { difficulty: difficulty });
      e.stopImmediatePropagation();
      return false;
    });
  }

  return {
    init: function () {
      initGameMenu('easy');
      initGameMenu('hard');
    }
  }
});
